import type { App, ComputedRef } from "vue";
import { reactive, computed, inject } from "vue";

interface ToolbarLoadingState {
  queue: number
  color: string
  height: number
}

export interface ToolbarLoadingBar extends ToolbarLoadingState {
  isActive: ComputedRef<boolean> | boolean
  start(): void
  finish(): void
}

const state: ToolbarLoadingState = reactive({
  queue: 0,
  color: "primary",
  height: 4,
});

const bar: ToolbarLoadingBar = reactive({
  ...state,
  isActive: computed(() => state.queue > 0),
  start(): void {
    state.queue++;
  },
  finish(): void {
    state.queue--;
  },
});

const ToolbarLoading = {
  install(app: App): void {
    app.config.globalProperties.$bar = bar;
    app.provide("bar", bar);
  },
};

export function useToolbarLoading(): ToolbarLoadingBar {
  return inject("bar", bar);
}

export default ToolbarLoading;
